import React, { useState } from 'react'

import {
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  TableRowStyled,
  TableRowHeadStyled,
  TableRowBodyStyled,
  TableColumnStyled,
  TableIconStyled,
  TableSubRowStyled,
  TableSubRowColumnStyled,
  TablePaginationStyled
} from './styles'
import Pagination from './../../molecules/Pagination'
import { IconAccordionArrow } from './../../../assets/svg/index'
import { TableProps, AccordionItemProps } from './types'
import { scrollToSection } from './../../../common/helpers'
import { useResponsiveValue } from '@theme-ui/match-media'

const Table: React.FC<TableProps> = ({ data, filteredData, withPagination, id }) => {
  const isTablet = useResponsiveValue([false, true, true, true], {
    defaultIndex: 0
  })

  // States
  const [currentPage, setCurrentPage] = useState(1)
  const [postsPerPage] = useState(10)

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = filteredData.slice(indexOfFirstPost, indexOfLastPost)

  // Change page
  const paginate = (pageNumber: number, symbolCode: string) => {
    setCurrentPage(pageNumber)
    setTimeout(function () {
      scrollToSection(`table-${id}`, 600, 0, -220)
    }, 100)
  }

  const AccordionItem: React.FC<AccordionItemProps> = ({ data, symbolCode }) => {
    const [isOpen, setIsOpen] = useState(false)
    const handleClick = (arg: number) => {
      setIsOpen(!isOpen)
      if (!isTablet) {
        setTimeout(function () {
          scrollToSection(`accordion-table-${id}-${arg}`, 600, 100, -120)
        }, 100)
      }
    }

    return (
      <TableRowStyled>
        <TableRowHeadStyled
          name={`accordion-table-${id}-${symbolCode}`}
          isOpened={isOpen}
          onClick={() => handleClick(symbolCode)}
          aria-expanded={isOpen}
        >
          <TableIconStyled>
            <IconAccordionArrow />
          </TableIconStyled>

          {data.map((el, index) => {
            return <TableColumnStyled key={`${Object.values(el)}-${index}`}>{Object.values(el)}</TableColumnStyled>
          })}
        </TableRowHeadStyled>
        <TableRowBodyStyled>
          {data.slice(2).map((element, i) => {
            return (
              <TableSubRowStyled key={`${Object.keys(element)}-${i}`}>
                {Object.entries(element)[0].map((rowItem, rowIndex) => {
                  return <TableSubRowColumnStyled key={`${rowItem}-${rowIndex}`}>{rowItem}</TableSubRowColumnStyled>
                })}
              </TableSubRowStyled>
            )
          })}
        </TableRowBodyStyled>
      </TableRowStyled>
    )
  }

  return (
    <TableContainerStyled name={`table-${id}`}>
      <TableStyled>
        <TableHeadStyled>
          <TableIconStyled></TableIconStyled>

          {data[0].map((el, index) => {
            return <TableColumnStyled key={`${Object.keys(el)}-${index}`}>{Object.keys(el)}</TableColumnStyled>
          })}
        </TableHeadStyled>
        {currentPosts.map((el, index) => {
          return <AccordionItem data={el} symbolCode={index} />
        })}
      </TableStyled>
      {withPagination && (
        <TablePaginationStyled>
          <Pagination currentPage={currentPage} postsPerPage={postsPerPage} totalPosts={filteredData.length} paginate={paginate} />
        </TablePaginationStyled>
      )}
    </TableContainerStyled>
  )
}

export default Table
